module.exports = __webpack_public_path__ + "static/media/legende_possible.2ca82d6b.svg";